import { render, staticRenderFns } from "./QuesDesigner.vue?vue&type=template&id=f929885c&scoped=true"
import script from "./QuesDesigner.vue?vue&type=script&lang=js"
export * from "./QuesDesigner.vue?vue&type=script&lang=js"
import style0 from "./QuesDesigner.vue?vue&type=style&index=0&id=f929885c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f929885c",
  null
  
)

export default component.exports